import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'

Vue.use(Router);

export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'Dashboard',
    meta: { title: '主页', icon: 'example',showKey:"always" },
    // hidden: true,
    children: [{
      path: 'dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '主页', icon: 'example',showKey:"always" },
    }]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/lesson_record_by_day',
    name: 'statistic',
    meta: { title: '数据统计大盘', icon: 'example' ,showKey:"always"},
    children: [
      {
        path: 'lesson_record_by_day',
        name: 'lesson_record_by_day',
        component: () => import('@/views/lesson/list/list_by_school'),
        meta: { title: '每日记录', icon: 'table', keepAlive: true }
      },
      {
        path: 'lesson_record_by_teacher',
        name: 'lesson_record_by_teacher',
        component: () => import('@/views/lesson/list/list_by_teacher'),
        meta: { title: '老师记录', icon: 'table', keepAlive: true }
      },
      {
        path: 'lesson_appraise_by_teacher',
        name: 'lesson_appraise_by_teacher',
        component: () => import('@/views/lesson/appraise_list/list.vue'),
        meta: { title: '点评记录', icon: 'table', keepAlive: true }
      },
      {
        path: 'private_card_rest',
        name: 'private_card_rest',
        component: () => import('@/views/statistic/rest/rest'),
        meta: { title: '剩余课统计', icon: 'table', keepAlive: true }
      }
    ]
  },
  {
    path: '/trial',
    component: Layout,
    redirect: '/trial/todo',
    name: 'Class',
    meta: { title: '试学管理', icon: 'example' },
    children: [
      {
        path: 'todo',
        name: 'TrialTodoList',
        component: () => import('@/views/trial/todo_list'),
        meta: { title: '待试学', icon: 'table', keepAlive: true }
      },
      {
        path: 'done',
        name: 'TrialDoneList',
        component: () => import('@/views/trial/done_list'),
        meta: { title: '已试学', icon: 'table', keepAlive: true }
      },
      {
        path: 'cards',
        name: 'TrialCards',
        component: () => import('@/views/trial/cards'),
        meta: { title: '待预约试学卡', icon: 'table', keepAlive: true }
      },
      {
        path: 'trial',
        name: 'TrialStat',
        component: () => import('@/views/trial/statistics'),
        meta: { title: '试学统计', icon: 'table', keepAlive: true }
      },
      {
        path: 'trial_record',
        name: 'TrialRecord',
        component: () => import('@/views/trial/record_list'),
        meta: { title: '试学视频', icon: 'table', keepAlive: true }
      }
    ]
  },

  {
    path: '/course',
    component: Layout,
    redirect: '/course/recharge',
    name: 'Course',
    meta: { title: '课程卡', icon: 'example' },
    children: [
      {
        path: 'recharge/list',
        name: 'Recharge',
        component: () => import('@/views/course/recharge/list'),
        meta: { title: '老卡补费升级增课', icon: 'table', keepAlive: true }
      },
      // {
      //   path: 'recharge/detail',
      //   name: 'RechargeDetail',
      //   component: () => import('@/views/course/recharge/detail'),
      //   meta: { title: '续卡详情', icon: 'table', keepAlive: true }
      // },
      {
        path: 'card/list',
        name: 'CardList',
        component: () => import('@/views/course/card/list'),
        meta: { title: '新卡列表', icon: 'table', keepAlive: false }
      },
      {
        path: 'card/total_list',
        name: 'CardTotalList',
        component: () => import('@/views/course/card/total_list'),
        meta: { title: '卡统计', icon: 'table', keepAlive: false,showKey:"system" }
      },
      {
        path: 'courses/list',
        name: 'CoursesList',
        component: () => import('@/views/course/courses/list'),
        meta: { title: '在售课程', icon: 'table', keepAlive: false }
      },
      // {
      //   path: 'card/detail',
      //   name: 'CardDetail',
      //   component: () => import('@/views/course/card/detail'),
      //   meta: { title: '卡详情', icon: 'table', keepAlive: false }
      // }
    ]
  },
  {
    path: '/student',
    component: Layout,
    redirect: '/student/table',
    name: 'Student',
    meta: { title: '学员管理', icon: 'example' },
    children: [
      {
        path: 'table',
        name: 'StudentTable',
        component: () => import('@/views/student/table/index'),
        meta: { title: '所有学员', icon: 'table', keepAlive: true }
      },
      {
        path: 'new',
        name: 'StudentNew',
        component: () => import('@/views/student/new/index'),
        meta: { title: '新建学员', icon: 'table', keepAlive: false }
      },
      {
        path: 'detail',
        name: 'StudentDetail',
        component: () => import('@/views/student/detail/index'),
        meta: { title: '学员详情', icon: 'table', keepAlive: true }
      }
    ]
  },
  // {
  //   path: '/class',
  //   component: Layout,
  //   redirect: '/class/table',
  //   name: 'Class',
  //   meta: { title: '课表', icon: 'example' },
  //   children: [
  //     {
  //       path: 'table',
  //       name: 'ClassToday',
  //       component: () => import('@/views/class/today/index'),
  //       meta: { title: '课表查询', icon: 'table', keepAlive: true }
  //     },
  //     {
  //       path: 'regular',
  //       name: 'ClassRegular',
  //       component: () => import('@/views/class/regular/index'),
  //       meta: { title: '固定课', icon: 'table', keepAlive: true }
  //     },
  //     {
  //       path: 'trial',
  //       name: 'TrialStat',
  //       component: () => import('@/views/class/trial/index'),
  //       meta: { title: '试学统计', icon: 'table', keepAlive: true }
  //     }
  //   ]
  // },

  {
    path: '/teacher',
    component: Layout,
    name: 'Teacher',
    redirect: '/teacher/table',
    meta: { title: '教师管理', icon: 'example' },
    children: [
      {
        path: 'table',
        name: 'TeacherTable',
        component: () => import('@/views/teacher/table/index'),
        meta: { title: '教师列表', icon: 'form', keepAlive: true }
      },
      {
        path: 'leave',
        name: 'TeacherLeaveTable',
        component: () => import('@/views/teacher/leave/index'),
        meta: { title: '离职教师', icon: 'form', keepAlive: true }
      },
      {
        path: 'detail',
        name: 'TeacherDetail',
        props: true,
        component: () => import('@/views/teacher/detail/index'),
        meta: { title: '教师详情', icon: 'table', keepAlive: true }
      },
      {
        path: 'category',
        name: 'TeacherCategory',
        props: true,
        component: () => import('@/views/teacher/category/index'),
        meta: { title: '教师分类', icon: 'table', keepAlive: true }
      },
      {
        path: 'holiday',
        name: 'TeacherHoliday',
        props: true,
        component: () => import('@/views/teacher/holiday/index'),
        meta: {title: '教师请假', icon: 'table', keepAlive: true}
      },
      // {
      //   path: 'salary_config',
      //   name: 'TeacherSalaryConfig',
      //   props: true,
      //   component: () => import('@/views/teacher/salary/config'),
      //   meta: {title: '工资默认配置', icon: 'table', keepAlive: true}
      // },
      // {
      //   path: 'salary_month',
      //   name: 'TeacherSalaryMonth',
      //   props: true,
      //   component: () => import('@/views/teacher/salary/month'),
      //   meta: {title: '月度工资', icon: 'table', keepAlive: true}
      // }
    ]
  },
  // {
  //   path: '/live-course',
  //   component: Layout,
  //   name: 'LiveCourse',
  //   redirect: '/live-course/list',
  //   meta: { title: '直播课管理', icon: 'example' },
  //   children: [
  //     {
  //       path: 'live',
  //       name: 'LiveCourseList',
  //       component: () => import('@/views/live-course/list/index'),
  //       meta: { title: '直播课列表', icon: 'table', keepAlive: true }
  //     },
  //     {
  //       path: 'new',
  //       name: 'NewLiveCourse',
  //       component: () => import('@/views/live-course/new/index'),
  //       meta: { title: '新建直播课', icon: 'form', keepAlive: true }
  //     },
  //     {
  //       path: 'detail',
  //       name: 'LiveCourseDetail',
  //       props: true,
  //       component: () => import('@/views/live-course/detail/index'),
  //       meta: { title: '直播课详情', icon: 'table', keepAlive: true }
  //     }
  //   ]
  // },
  {
    path: '/billing',
    component: Layout,
    name: 'employee',
    redirect: '/billing/employee_list',
    meta: { title: '账务管理', icon: 'example' },
    children: [
      {
        path: 'employee_list',
        name: 'employee_list',
        component: () => import('@/views/billing/employee/employee'),
        meta: { title: '员工列表', icon: 'table', keepAlive: true }
      },
      {
        path: 'salary_month',
        name: 'salary_month',
        component: () => import('@/views/billing/salary_month/salary_month'),
        meta: { title: '员工工资', icon: 'form', keepAlive: true }
      },
      {
        path: 'fee_month_table',
        name: 'fee_month_table',
        props: true,
        component: () => import('@/views/billing/fee_month_table'),
        meta: { title: '校区收支', icon: 'table', keepAlive: true }
      },
      {
        path: 'school_pay_lesson',
        name: 'SchoolPayLesson',
        props: true,
        component: () => import('@/views/billing/school_pay_lesson'),
        meta: { title: '校区应付', icon: 'table', keepAlive: true }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    name: 'orders',
    redirect: '/order/pay_request',
    meta: { title: '订单管理', icon: 'example' },
    children: [
      {
        path: 'pay_request',
        name: 'PayRequest',
        component: () => import('@/views/order/pay_request'),
        meta: { title: '支付请求', icon: 'table', keepAlive: true }
      },
      {
        path: 'order_list',
        name: 'OrderList',
        component: () => import('@/views/order/order_list'),
        meta: { title: '订单列表', icon: 'table', keepAlive: true }
      }
    ]
  },
  {
    path: '/member',
    component: Layout,
    name: 'Member',
    redirect: '/member/detail',
    meta: { title: '会员管理', icon: 'example' },
    // hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        component: () => import('@/views/member/detail'),
        meta: { title: '会员详情', icon: 'table', keepAlive: true }
      }
    ]
  },
  {
    path: '/coupon',
    component: Layout,
    name: 'Coupon',
    redirect: '/coupon/list',
    meta: { title: '优惠券管理', icon: 'nested' },
    children: [
      {
        path: 'new',
        name: 'newCouponTemplate',
        component: () => import('@/views/coupon/new/index'),
        meta: { title: '创建优惠券', icon: 'nested', keepAlive: true },
        children: [
          {
            path: 'new/dazhe',
            name: 'newDaZheCouponTemplate',
            component: () => import('@/views/coupon/new/dazhe/index'),
            meta: { title: '打折券', icon: 'form', keepAlive: true }
          },
          {
            path: 'new/manjian',
            name: 'newManJianCouponTemplate',
            component: () => import('@/views/coupon/new/manjian/index'),
            meta: { title: '满减券', icon: 'form', keepAlive: true }
          }
        ]
      },
      {
        path: 'list',
        name: 'CouponList',
        component: () => import('@/views/coupon/list/index'),
        meta: { title: '优惠券列表', icon: 'table', keepAlive: true }
      },
      {
        path: 'send_coupon',
        name: 'SendCoupon',
        component: () => import('@/views/coupon/manage/send'),
        meta: { title: '赠送优惠券', icon: 'table', keepAlive: true }
      },
      {
        path: 'detail',
        name: 'CouponDetail',
        props: true,
        component: () => import('@/views/coupon/detail/index'),
        meta: { title: '优惠券详情', icon: 'table', keepAlive: true }
      },
      {
        path: 'ticket_list',
        name: 'CouponTicketList',
        component: () => import('@/views/coupon/ticket_list/index'),
        meta: { title: '领取列表', icon: 'table', keepAlive: true }
      },
      {
        path: 'tag',
        name: 'CouponTagList',
        component: () => import('@/views/coupon/tag/index'),
        meta: { title: '标签管理', icon: 'table', keepAlive: true }
      }
    ]
  },
  {
    path: '/music',
    component: Layout,
    redirect: '/music/upload',
    name: 'Music',
    meta: { title: '歌曲伴奏', icon: 'example' },
    children: [
      {
        path: 'list',
        name: 'MusicList',
        component: () => import('@/views/music/list/index'),
        meta: { title: '歌曲列表', icon: 'table', keepAlive: false }
      },
      // {
      //   path: 'detail',
      //   name: 'MusicDetail',
      //   component: () => import('@/views/music/detail/index'),
      //   meta: { title: '歌曲详情', icon: 'table', keepAlive: true }
      // },

      {
        path: 'new_oss_lrc',
        name: 'MusicUploadLRC',
        component: () => import('@/views/music/new/new_oss_lrc'),
        meta: { title: '上传-LRC', icon: 'table', keepAlive: true }
      },
      {
        path: 'new_oss_lrc_content',
        name: 'MusicUploadLRCContent',
        component: () => import('@/views/music/new/new_oss_lrc_content'),
        meta: { title: '上传-编辑Lrc', icon: 'table', keepAlive: true }
      },

    ]
  },
  {
    path: '/manager',
    component: Layout,
    redirect: '/manager/console',
    name: 'Manager',
    meta: { title: '系统管理', icon: 'example' },
    children: [
      {
        path: 'console',
        name: 'ManagerConsole',
        component: () => import('@/views/manager/console'),
        meta: { title: '控制台', icon: 'table', keepAlive: true,showKey:"always" }
      },
      {
        path: 'rtclog',
        name: 'RtcRoomLog',
        component: () => import('@/views/manager/rtclog'),
        meta: { title: 'RTCRoom', icon: 'table', keepAlive: true }
      },
      {
        path: 'log_event',
        name: 'LogEvent',
        component: () => import('@/views/manager/log_event'),
        meta: { title: 'LogEvent', icon: 'table', keepAlive: true }
      },
      {
        path: 'log_sms',
        name: 'LogSms',
        component: () => import('@/views/manager/log_sms'),
        meta: { title: 'LogSms', icon: 'table', keepAlive: true }
      },
      {
        path: 'footprint',
        name: 'Footprint',
        component: () => import('@/views/manager/footprint'),
        meta: { title: 'Footprint', icon: 'table', keepAlive: true }
      },
      // {
      //   path: 'managers',
      //   name: 'Managers',
      //   component: () => import('@/views/manager/console2'),
      //   meta: { title: '控制台2', icon: 'table', keepAlive: true }
      // }
    ]
  },
  // {
  //   path: '/nested',
  //   component: Layout,
  //   redirect: '/nested/menu1',
  //   name: 'nested',
  //   meta: {
  //     title: 'nested',
  //     icon: 'nested'
  //   },
  //   children: [
  //     {
  //       path: 'menu1',
  //       component: () => import('@/views/nested/menu1/index'), // Parent router-view
  //       name: 'menu1',
  //       meta: { title: 'menu1' },
  //       children: [
  //         {
  //           path: 'menu1-1',
  //           component: () => import('@/views/nested/menu1/menu1-1'),
  //           name: 'menu1-1',
  //           meta: { title: 'menu1-1' }
  //         },
  //         {
  //           path: 'menu1-2',
  //           component: () => import('@/views/nested/menu1/menu1-2'),
  //           name: 'menu1-2',
  //           meta: { title: 'menu1-2' },
  //           children: [
  //             {
  //               path: 'menu1-2-1',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  //               name: 'menu1-2-1',
  //               meta: { title: 'menu1-2-1' }
  //             },
  //             {
  //               path: 'menu1-2-2',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
  //               name: 'menu1-2-2',
  //               meta: { title: 'menu1-2-2' }
  //             }
  //           ]
  //         },
  //         {
  //           path: 'menu1-3',
  //           component: () => import('@/views/nested/menu1/menu1-3'),
  //           name: 'menu1-3',
  //           meta: { title: 'menu1-3' }
  //         }
  //       ]
  //     },
  //     {
  //       path: 'menu2',
  //       component: () => import('@/views/nested/menu2/index'),
  //       meta: { title: 'menu2' }
  //     }
  //   ]
  // },
  { path: '*', redirect: '/404', hidden: true }
];
export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js